module.exports = __webpack_public_path__ + "static/media/pic1.b7c0b9ec.jpg";